/**
 * FAQ Block — animated accordion using the Web Animations API.
 * Animates <details> height on open/close since CSS cannot transition
 * the native details/summary show/hide behaviour.
 * Respects prefers-reduced-motion.
 */

const DURATION = 250;
const EASING = 'cubic-bezier(0.23, 1, 0.32, 1)';

const prefersReducedMotion = window.matchMedia(
  '(prefers-reduced-motion: reduce)',
).matches;

const animateDetails = (details, opening) => {
  if (details._animation) {
    details._animation.cancel();
  }

  // Measure closed height (summary only)
  const closedHeight = details.querySelector('.block-faq__question').offsetHeight;

  // Measure open height — temporarily force open to read it
  details.setAttribute('open', '');
  const openHeight = details.offsetHeight;

  if (prefersReducedMotion) {
    if (!opening) details.removeAttribute('open');
    return;
  }

  // Pin current height and clip so animation controls visibility
  details.style.height = `${opening ? closedHeight : openHeight}px`;
  details.style.overflow = 'hidden';

  // Remove open immediately on close so the +/− indicator swaps at the start
  if (!opening) {
    details.removeAttribute('open');
  }

  const animation = details.animate(
    [
      { height: `${opening ? closedHeight : openHeight}px` },
      { height: `${opening ? openHeight : closedHeight}px` },
    ],
    { duration: DURATION, easing: EASING },
  );

  details._animation = animation;

  animation.onfinish = () => {
    details._animation = null;
    details.style.height = '';
    details.style.overflow = '';
  };
};

const faqBlocks = document.querySelectorAll('.block-faq');

faqBlocks.forEach((block) => {
  block.querySelectorAll('.block-faq__item').forEach((details) => {
    const summary = details.querySelector('.block-faq__question');

    if (!summary) return;

    summary.addEventListener('click', (e) => {
      e.preventDefault();

      const isOpen = details.hasAttribute('open');

      if (!isOpen) {
        block.querySelectorAll('.block-faq__item[open]').forEach((item) => {
          if (item !== details) {
            animateDetails(item, false);
          }
        });
      }

      animateDetails(details, !isOpen);
    });
  });
});
